import { render, staticRenderFns } from "./MessageEditorConfirm.vue?vue&type=template&id=24551524&scoped=true&"
import script from "./MessageEditorConfirm.vue?vue&type=script&lang=js&"
export * from "./MessageEditorConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorConfirm.vue?vue&type=style&index=0&id=24551524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24551524",
  null
  
)

export default component.exports